import Vue from 'vue';
import * as C from '../constants';
import defaultState from '../triggers/defaultState';

export default {
  [C.TRIGGERS_RESET](state) {
    Object.assign(state, defaultState());
  },

  // <editor-fold desc="Domains">
  [C.TRIGGERS_DOMAINS_PENDING](state) {
    state.domains = {
      ...state.domains,
      loading: true,
    };
  },

  [C.TRIGGERS_DOMAINS_SUCCESS](state, domains) {
    state.domains = {
      loading: false,
      error: false,
      noContent: false,
      items: domains,
    };
  },

  [C.TRIGGERS_DOMAINS_FAILURE](state) {
    state.domains = {
      loading: false,
      error: true,
      noContent: false,
      items: [],
    };
  },

  [C.TRIGGERS_DOMAINS_NO_CONTENT](state) {
    state.domains = {
      loading: false,
      error: false,
      noContent: true,
      items: [],
    };
  },
  // </editor-fold>

  [C.TRIGGERS_TYPES_PENDING](state) {
    state.types = {
      ...state.types,
      loading: true,
      error: false,
    };
    state.templates.triggerType = null;
    state.rules.triggerType = null;
  },

  [C.TRIGGERS_TYPES_SUCCESS](state, types) {
    state.types = {
      loading: false,
      error: false,
      items: types,
    };
  },

  [C.TRIGGERS_TYPES_FAILURE](state) {
    state.domains = {
      loading: false,
      error: true,
      items: [],
    };
  },

  [C.TRIGGERS_TYPES_NO_CONTENT](state) {
    state.domains = {
      loading: false,
      error: false,
      items: [],
    };
  },

  [C.TRIGGERS_TEMPLATES_DOMAIN_SET](state, domain) {
    state.templates.domain = domain;
  },

  [C.TRIGGERS_TEMPLATES_TRIGGER_TYPE_SET](state, triggerType) {
    state.templates.triggerType = triggerType;
  },

  [C.TRIGGERS_TEMPLATES_PENDING](state) {
    state.templates.templates = {
      ...state.templates.templates,
      noContent: false,
      loading: true,
      error: false,
    };
  },

  [C.TRIGGERS_TEMPLATES_SUCCESS](state, templates) {
    state.templates.templates = {
      ...state.templates.templates,
      loading: false,
      items: templates,
    };
  },

  [C.TRIGGERS_TEMPLATES_FAILURE](state) {
    state.templates.templates = {
      ...state.templates.templates,
      loading: false,
      error: true,
      items: [],
    };
  },

  [C.TRIGGERS_TEMPLATES_NO_CONTENT](state) {
    state.templates.templates = {
      ...state.templates.templates,
      loading: false,
      noContent: true,
      items: [],
    };
  },

  [C.TRIGGERS_TEMPLATE_SAVE_PENDING](state) {
    state.templates.save = {
      loading: true,
      error: false,
    };
  },

  [C.TRIGGERS_TEMPLATE_SAVE_SUCCESS](state) {
    state.templates.save = {
      loading: false,
      error: false,
    };
  },

  [C.TRIGGERS_TEMPLATE_SAVE_FAILURE](state) {
    state.templates.save = {
      loading: false,
      error: true,
    };
  },
  // </editor-fold>

  // <editor-fold desc="Rules">
  [C.TRIGGERS_RULES_DOMAIN_SET](state, domain) {
    state.rules.domain = domain;
  },

  [C.TRIGGERS_RULES_TRIGGER_TYPE_SET](state, triggerType) {
    state.rules.triggerType = triggerType;
  },

  [C.TRIGGERS_RULES_PENDING](state) {
    state.rules.rules = {
      item: {},
      noContent: false,
      loading: true,
      error: false,
    };
  },

  [C.TRIGGERS_RULES_SUCCESS](state, rule) {
    Vue.set(state.rules, 'rules', {
      ...state.rules.rules,
      loading: false,
      item: rule,
    });
  },

  [C.TRIGGERS_RULES_FAILURE](state) {
    state.rules.rules = {
      ...state.rules.rules,
      loading: false,
      error: true,
      item: {},
    };
  },

  [C.TRIGGERS_RULES_NO_CONTENT](state) {
    state.rules.rules = {
      ...state.rules.rules,
      loading: false,
      noContent: true,
      item: {
        templates: [],
        isLatest: true,
      },
    };
  },

  [C.TRIGGERS_RULES_TEMPLATES_ADD](state, payload) {
    state.rules.rules.item.templates.push(payload);
  },

  [C.TRIGGERS_RULES_TEMPLATES_DELETE](state, payload) {
    state.rules.rules.item.templates.splice(payload.index, 1);
    state.rules.rules.item.templates.forEach((template) => {
      if (template.order > payload.order) {
        template.order -= 1;
      }
    });
  },

  [C.TRIGGERS_RULES_TEMPLATES_SWAP_ORDER](state, payload) {
    const templates = state.rules.rules.item.templates;
    const fromOrder = templates[payload.from].order;
    templates[payload.from].order = templates[payload.to].order;
    templates[payload.to].order = fromOrder;
  },

  [C.TRIGGERS_RULES_TEMPLATES_PENDING](state) {
    state.rules.templates = {
      ...state.rules.templates,
      noContent: false,
      loading: true,
      error: false,
    };
  },

  [C.TRIGGERS_RULES_TEMPLATES_SUCCESS](state, templates) {
    state.rules.templates = {
      ...state.rules.templates,
      loading: false,
      items: templates,
    };
  },

  [C.TRIGGERS_RULES_TEMPLATES_FAILURE](state) {
    state.rules.templates = {
      ...state.rules.templates,
      loading: false,
      error: true,
      items: [],
    };
  },

  [C.TRIGGERS_RULES_TEMPLATES_NO_CONTENT](state) {
    state.rules.templates = {
      ...state.rules.templates,
      loading: false,
      noContent: true,
      items: [],
    };
  },

  [C.TRIGGERS_RULES_TEMPLATES_UPDATE](state, payload) {
    Vue.set(state.rules.rules.item.templates, payload.index, payload.template);
  },

  [C.TRIGGERS_RULES_SAVE_PENDING](state) {
    state.rules.save = {
      loading: true,
      error: false,
    };
  },

  [C.TRIGGERS_RULES_SAVE_SUCCESS](state) {
    Vue.set(state.rules.rules, 'item', {});
    state.rules.save = {
      loading: false,
      error: false,
    };
  },

  [C.TRIGGERS_RULES_SAVE_FAILURE](state) {
    state.rules.save = {
      loading: false,
      error: true,
    };
  },

  [C.TRIGGERS_RULES_REVISIONS_PENDING](state) {
    state.rules.revisions = {
      items: [],
      loading: true,
      noContent: false,
      error: false,
    };
  },

  [C.TRIGGERS_RULES_REVISIONS_SUCCESS](state, payload) {
    state.rules.revisions = {
      ...state.rules.revisions,
      items: payload,
      loading: false,
    };
  },

  [C.TRIGGERS_RULES_REVISIONS_FAILURE](state) {
    state.rules.revisions = {
      ...state.rules.revisions,
      loading: false,
      error: true,
    };
  },

  [C.TRIGGERS_RULES_REVISIONS_NO_CONTENT](state) {
    state.rules.revisions = {
      ...state.rules.revisions,
      loading: false,
      noContent: true,
    };
  },

  [C.TRIGGERS_RULES_REVISIONS_CURRENT](state, payload) {
    state.rules.currentRevision = payload;
  },

  [C.TRIGGERS_RULES_SETTINGS_PENDING](state) {
    state.rules.settings.list = {
      items: [],
      loading: true,
      error: false,
      noContent: false,
    };
  },

  [C.TRIGGERS_RULES_SETTINGS_SUCCESS](state, payload) {
    state.rules.settings.list = {
      ...state.rules.settings.list,
      items: payload,
      loading: false,
    };
  },

  [C.TRIGGERS_RULES_SETTINGS_FAILURE](state) {
    state.rules.settings.list = {
      ...state.rules.settings.list,
      loading: false,
      error: true,
    };
  },

  [C.TRIGGERS_RULES_SETTINGS_NO_CONTENT](state) {
    state.rules.settings.list = {
      ...state.rules.settings.list,
      loading: false,
      noContent: true,
    };
  },

  [C.TRIGGERS_RULES_SETTINGS_ACTION_PENDING](state) {
    state.rules.settings.action = {
      loading: true,
      error: false,
    };
  },

  [C.TRIGGERS_RULES_SETTINGS_ACTION_SUCCESS](state) {
    state.rules.settings.action = {
      loading: false,
      error: false,
    };
  },

  [C.TRIGGERS_RULES_SETTINGS_ACTION_FAILURE](state) {
    state.rules.settings.action = {
      loading: false,
      error: true,
    };
  },

  [C.TRIGGERS_RULES_SETTINGS_DELETE_PENDING](state) {
    state.rules.settings.delete = {
      loading: true,
      error: false,
    };
  },

  [C.TRIGGERS_RULES_SETTINGS_DELETE_SUCCESS](state) {
    state.rules.settings.delete = {
      loading: false,
      error: false,
    };
  },

  [C.TRIGGERS_RULES_SETTINGS_DELETE_FAILURE](state) {
    state.rules.settings.delete = {
      loading: false,
      error: true,
    };
  },

  [C.TRIGGERS_RULES_SETTINGS_LOGS_PENDING](state) {
    state.rules.settings.logs = {
      items: [],
      loading: true,
      error: false,
    };
  },

  [C.TRIGGERS_RULES_SETTINGS_LOGS_SUCCESS](state, payload) {
    state.rules.settings.logs = {
      items: payload,
      loading: false,
      error: false,
    };
  },

  [C.TRIGGERS_RULES_SETTINGS_LOGS_FAILURE](state) {
    state.rules.settings.logs = {
      items: [],
      loading: false,
      error: true,
    };
  },
  // </editor-fold>

  // <editor-fold desc="Lists">
  [C.TRIGGERS_LISTS_PREVIEW_PENDING](state) {
    state.lists.preview = {
      loading: true,
      error: false,
      item: undefined,
    };
  },

  [C.TRIGGERS_LISTS_PREVIEW_SUCCESS](state, payload) {
    state.lists.preview = {
      loading: false,
      item: payload,
    };
  },

  [C.TRIGGERS_LISTS_PREVIEW_FAILURE](state) {
    state.lists.preview = {
      loading: false,
      error: true,
    };
  },

  [C.TRIGGERS_LISTS_OVERVIEW_PENDING](state) {
    state.lists.overview = {
      loading: true,
      error: false,
      item: undefined,
    };
  },

  [C.TRIGGERS_LISTS_OVERVIEW_SUCCESS](state, payload) {
    state.lists.overview = {
      loading: false,
      item: payload,
    };
  },

  [C.TRIGGERS_LISTS_OVERVIEW_FAILURE](state) {
    state.lists.overview = {
      loading: false,
      error: true,
    };
  },

  [C.TRIGGERS_LISTS_LIST_PENDING](state) {
    state.lists.list = {
      loading: true,
      error: false,
      items: [],
    };
  },

  [C.TRIGGERS_LISTS_LIST_SUCCESS](state, payload) {
    state.lists.list = {
      loading: false,
      items: payload,
    };
  },

  [C.TRIGGERS_LISTS_LIST_FAILURE](state) {
    state.lists.list = {
      loading: false,
      error: true,
    };
  },

  [C.TRIGGERS_LISTS_MESSAGES_PENDING](state, payload) {
    Vue.set(state.lists.messages, 'booking', payload);
    state.lists.messages.messages = {
      loading: true,
      error: false,
      items: [],
    };
  },

  [C.TRIGGERS_LISTS_MESSAGES_SUCCESS](state, payload) {
    state.lists.messages.messages = {
      loading: false,
      items: payload,
    };
  },

  [C.TRIGGERS_LISTS_MESSAGES_FAILURE](state) {
    state.lists.messages.messages = {
      loading: false,
      error: true,
    };
  },

  [C.TRIGGERS_LISTS_FILTERS_UPDATE](state, payload) {
    Vue.set(state.lists, 'filters', payload);
  },
  // </editor-fold>
};



// WEBPACK FOOTER //
// ./src/store/modules/triggers/mutations.js